import { z } from "zod";

export const AddressSchema = z.object({
  addressId: z.string().optional(),
  street: z.string().min(3, { message: "Rua inválida" }),
  number: z.string().min(1, { message: "Número inválido" }),
  complement: z.string().optional(),
  district: z.string().min(1, { message: "Bairro inválido" }),
  city: z.string().min(3, { message: "Cidade inválida" }),
  state: z.string().min(2, { message: "Estado inválido" }),
  zip_code: z.preprocess(
    (val) => (typeof val === "string" ? val.replace(/\D/g, "") : val),
    z.string().regex(/^\d{8}$/, { message: "CEP inválido" }),
  ),
  country: z.string().optional().default("Brasil"),
});

export const CreateSalonFormSchema = z.object({
  name: z.string().min(1, { message: "Nome é obrigatório" }),
  email: z
    .string()
    .min(1, { message: "E-mail é obrigatório" })
    .email({ message: "E-mail inválido" }),
  cpfCnpj: z
    .string({
      required_error: "CPF/CNPJ é obrigatório.",
    })
    .refine((doc) => {
      const replacedDoc = doc.replace(/\D/g, "");
      return replacedDoc.length >= 11;
    }, "CPF/CNPJ deve conter no mínimo 11 caracteres.")
    .refine((doc) => {
      const replacedDoc = doc.replace(/\D/g, "");
      return replacedDoc.length <= 14;
    }, "CPF/CNPJ deve conter no máximo 14 caracteres.")
    .refine((doc) => {
      const replacedDoc = doc.replace(/\D/g, "");
      return !!Number(replacedDoc);
    }, "CPF/CNPJ deve conter apenas números."),
  whatsapp: z.string().min(13, { message: "Whatsapp inválido" }).max(13, {
    message: "Whatsapp inválido",
  }),
  secondary_whatsapp: z.string().optional(),

  addresses: z.array(AddressSchema).optional().default([]),
});

export type CreateSalonData = z.infer<typeof CreateSalonFormSchema>;
export type AddressData = z.infer<typeof AddressSchema>;
